// Panel (Dashboard) widget kataloğu + hazır düzen (preset) tanımları.
// Dashboard.js (render) ve DashboardDesign.jsx (ayar ekranı) paylaşır.
import { LayoutDashboard, Cog, Wallet, Boxes, BarChart3, ListChecks, TrendingUp } from "lucide-react";

// Her widget: title (Türkçe), group (Panel Tasarımı gruplaması), span (4'lük grid'te sütun genişliği),
// perm (opsiyonel — yalnız bu yetki/koşul varsa gösterilir; "can_purchase" = maliyet/kâr görebilen roller).
export const WIDGET_CATALOG = {
  card_daily_summary: { title: "Bugün Ne Oldu? (Günlük Özet)", group: "Durum & Sağlık", span: 4 },
  kpi_revenue_today: { title: "Bugün Ciro", group: "Özet Metrikler", span: 1 },
  kpi_profit_today: { title: "Bugün Kâr", group: "Özet Metrikler", span: 1, perm: "can_purchase" },
  kpi_open_carts: { title: "Bekleyen Sepetler", group: "Özet Metrikler", span: 1 },
  kpi_inventory_value: { title: "Stok Değeri", group: "Özet Metrikler", span: 1, perm: "can_purchase" },
  kpi_product_count: { title: "Ürün Sayısı", group: "Özet Metrikler", span: 1 },
  kpi_low_stock_count: { title: "Düşük Stok", group: "Özet Metrikler", span: 1 },
  kpi_expiring_count: { title: "SKT Yaklaşan", group: "Özet Metrikler", span: 1 },
  kpi_ai_prices: { title: "AI Fiyat (bugün)", group: "Özet Metrikler", span: 1 },
  kpi_opportunities: { title: "Tedarik Fırsatı", group: "Özet Metrikler", span: 1, perm: "can_purchase" },
  kpi_market_alerts: { title: "Piyasa Uyarısı", group: "Özet Metrikler", span: 1, perm: "can_purchase" },
  kpi_avg_basket: { title: "Ortalama Sepet", group: "Satış Analitiği", span: 1 },
  chart_revenue_7d: { title: "Son 7 Gün Ciro", group: "Grafikler", span: 2 },
  chart_category_dist: { title: "Kategori Dağılımı", group: "Grafikler", span: 2 },
  chart_payment_mix: { title: "Ödeme Yöntemi Dağılımı", group: "Grafikler", span: 2 },
  chart_weekly_profit: { title: "Haftalık Kâr Trendi", group: "Grafikler", span: 2, perm: "can_purchase" },
  chart_hourly_heatmap: { title: "Saatlik Satış Isı Haritası", group: "Satış Analitiği", span: 4 },
  progress_catalog: { title: "Katalog Hazırlık", group: "Durum & Sağlık", span: 2 },
  grid_integration_health: { title: "Entegrasyon Sağlığı", group: "Durum & Sağlık", span: 2 },
  card_ai_insights: { title: "Yapay Zeka Öngörüleri", group: "Durum & Sağlık", span: 2 },
  card_ai_images: { title: "AI Toplu Görsel Üretimi", group: "Durum & Sağlık", span: 2, perm: "is_admin" },
  card_expiry_alert: { title: "SKT & Karantina Uyarısı", group: "Durum & Sağlık", span: 4 },
  card_vehicle_docs: { title: "Belgesi Yakında Dolan Araçlar", group: "Durum & Sağlık", span: 2, perm: "logistics" },
  table_cash_location: { title: "Bugün Kasa (Lokasyon)", group: "Listeler & Tablolar", span: 4 },
  list_sales_analysis: { title: "Satış Analizi (30 Gün)", group: "Listeler & Tablolar", span: 4 },
  card_top_customer: { title: "Bugünün En İyi Müşterisi", group: "Satış Analitiği", span: 2 },
  card_shift_reco: { title: "AI Vardiya Önerisi", group: "Satış Analitiği", span: 2 },
  card_top_brands: { title: "En Kârlı Markalar (30 Gün)", group: "Satış Analitiği", span: 2, perm: "can_purchase" },
  card_revenue_channels: { title: "Günlük Ciro — Kanal Kırılımı", group: "Finans", span: 2 },
  list_low_stock: { title: "Düşük Stok Listesi", group: "Listeler & Tablolar", span: 2 },
  list_expiring: { title: "SKT Yaklaşan Ürünler", group: "Listeler & Tablolar", span: 2 },
  list_reorder: { title: "Yeniden Sipariş Önerisi", group: "Listeler & Tablolar", span: 4, perm: "can_purchase" },
  cards_supply_ops: { title: "Tedarik Fırsatları", group: "Listeler & Tablolar", span: 4, perm: "can_purchase" },
};

export const WIDGET_ORDER = Object.keys(WIDGET_CATALOG);
export const WIDGET_GROUP_ORDER = ["Özet Metrikler", "Satış Analitiği", "Grafikler", "Durum & Sağlık", "Listeler & Tablolar"];

// Piyasa analizli 8 hazır düzen (Shopify / Odoo / Square / Lightspeed / Zoho esinli).
export const DASHBOARD_PRESETS = [
  { id: "executive", name: "Yönetici Özeti", icon: LayoutDashboard, description: "En önemli finans + operasyon metrikleri — az ve öz.", layout: ["card_daily_summary", "kpi_revenue_today", "kpi_profit_today", "kpi_avg_basket", "kpi_open_carts", "card_ai_insights", "card_vehicle_docs", "chart_revenue_7d", "chart_payment_mix", "card_revenue_channels", "list_sales_analysis", "card_top_customer", "card_top_brands", "card_shift_reco"] },
  { id: "operations", name: "Operasyon Odaklı", icon: Cog, description: "Günlük mağaza/depo işleyişi, entegrasyon ve kasa durumu.", layout: ["progress_catalog", "grid_integration_health", "card_vehicle_docs", "kpi_open_carts", "kpi_product_count", "chart_hourly_heatmap", "table_cash_location", "list_reorder", "card_shift_reco", "card_ai_images"] },
  { id: "finance", name: "Finans Odaklı", icon: Wallet, description: "Nakit akışı, kârlılık ve ciro analizi.", layout: ["kpi_revenue_today", "kpi_profit_today", "kpi_avg_basket", "kpi_inventory_value", "kpi_ai_prices", "chart_revenue_7d", "chart_payment_mix", "card_revenue_channels", "chart_weekly_profit", "table_cash_location", "card_top_customer", "card_top_brands"] },
  { id: "sales", name: "Satış Odaklı", icon: TrendingUp, description: "En çok satanlar, kategori analizi ve ciro trendi.", layout: ["kpi_revenue_today", "kpi_open_carts", "card_top_customer", "list_sales_analysis", "chart_hourly_heatmap", "chart_revenue_7d", "chart_category_dist", "card_shift_reco"] },
  { id: "inventory", name: "Stok & Tedarik", icon: Boxes, description: "Kritik stok, SKT ve tedarik fırsatları.", layout: ["kpi_low_stock_count", "kpi_expiring_count", "kpi_inventory_value", "card_expiry_alert", "card_vehicle_docs", "list_low_stock", "list_expiring", "cards_supply_ops"] },
  { id: "compact", name: "Kompakt (Yoğun)", icon: ListChecks, description: "Her şeyi küçük kartlarda aynı anda gör.", layout: ["kpi_revenue_today", "kpi_profit_today", "kpi_open_carts", "kpi_low_stock_count", "kpi_expiring_count", "kpi_product_count", "grid_integration_health", "list_low_stock", "list_sales_analysis"] },
  { id: "charts", name: "Grafik Ağırlıklı", icon: BarChart3, description: "Tablolar yerine görsel grafikler ve trendler.", layout: ["kpi_revenue_today", "kpi_profit_today", "chart_revenue_7d", "chart_hourly_heatmap", "chart_payment_mix", "chart_weekly_profit", "chart_category_dist", "card_ai_insights"] },
  { id: "classic", name: "Klasik (Tam)", icon: LayoutDashboard, description: "Tüm bileşenlerin geleneksel tam görünümü.", layout: ["kpi_revenue_today", "kpi_open_carts", "kpi_profit_today", "kpi_avg_basket", "kpi_inventory_value", "kpi_product_count", "kpi_low_stock_count", "kpi_expiring_count", "kpi_opportunities", "kpi_market_alerts", "kpi_ai_prices", "progress_catalog", "card_expiry_alert", "card_vehicle_docs", "grid_integration_health", "table_cash_location", "card_ai_insights", "chart_revenue_7d", "chart_category_dist", "chart_payment_mix", "card_revenue_channels", "chart_weekly_profit", "chart_hourly_heatmap", "list_sales_analysis", "card_top_customer", "card_top_brands", "list_low_stock", "list_expiring", "list_reorder", "cards_supply_ops", "card_shift_reco", "card_ai_images"] },
];

export function presetEnabledMap(presetId) {
  const p = DASHBOARD_PRESETS.find((x) => x.id === presetId);
  const layout = p ? p.layout : [];
  const m = {};
  WIDGET_ORDER.forEach((k) => { m[k] = layout.includes(k); });
  return m;
}

// Görünecek widget anahtarları (sıralı). Preset seçiliyse preset düzeni, "custom" ise
// kullanıcının sürükle-bırak sırası (order) + sırada olmayan yeni açılanlar sona eklenir.
export function resolveVisibleWidgets(cfg) {
  if (cfg && cfg.preset && cfg.preset !== "custom") {
    const p = DASHBOARD_PRESETS.find((x) => x.id === cfg.preset);
    if (p) return p.layout;
  }
  const en = (cfg && cfg.enabled) || {};
  const enabledKeys = WIDGET_ORDER.filter((k) => en[k]);
  const order = Array.isArray(cfg?.order) ? cfg.order.filter((k) => en[k] && WIDGET_ORDER.includes(k)) : [];
  const rest = enabledKeys.filter((k) => !order.includes(k));
  return [...order, ...rest];
}

export const DEFAULT_DASHBOARD_CONFIG = {
  preset: "executive",
  enabled: presetEnabledMap("executive"),
  density: "rahat",
  card_style: "golgeli",
  order: [],
};

export function normalizeConfig(raw) {
  if (!raw || typeof raw !== "object" || !raw.preset) return { ...DEFAULT_DASHBOARD_CONFIG };
  const preset = raw.preset;
  const density = raw.density === "kompakt" ? "kompakt" : "rahat";
  const card_style = ["golgeli", "cizgili", "duz"].includes(raw.card_style) ? raw.card_style : "golgeli";
  let enabled = raw.enabled && typeof raw.enabled === "object" ? raw.enabled : {};
  if (preset !== "custom") enabled = presetEnabledMap(preset);
  const order = Array.isArray(raw.order) ? raw.order.filter((k) => WIDGET_ORDER.includes(k)) : [];
  return { preset, enabled, density, card_style, order };
}

// Sektöre göre önerilen varsayılan panel düzeni (Sistem Ayarları → Sektörler kodları).
export const SECTOR_PRESET_MAP = {
  market: "operations",
  magaza: "sales",
  eticaret: "charts",
  depo: "inventory",
  toptan: "inventory",
  otel: "operations",
  kafe: "sales",
  restoran: "sales",
  uretim: "operations",
  teknik_servis: "operations",
  tarim: "inventory",
  gida: "operations",
  reklam: "finance",
  yazilim: "executive",
};

export function recommendedPreset(sectorCode) {
  return SECTOR_PRESET_MAP[sectorCode] || "executive";
}

// Role göre akıllı varsayılan panel düzeni (kullanıcı hiç kaydetmemişse).
export const ROLE_PRESET_MAP = {
  admin: "executive",
  assistant: "executive",
  store_manager: "operations",
  warehouse: "inventory",
  accountant: "finance",
};

// Öncelik: role göre öneri → yoksa sektöre göre → yoksa executive.
export function defaultPresetFor(role, sectorCode) {
  return ROLE_PRESET_MAP[role] || recommendedPreset(sectorCode);
}
